import { Fragment, type ReactNode } from "react";

/** Markdown mínimo y seguro: párrafos, viñetas (- / •), negritas (**x**), cursivas (*x*). Sin HTML crudo. */
export function Markdown({ text }: { text: string }) {
  const lines = text.split("\n");
  const out: ReactNode[] = [];
  let list: string[] = [];
  let para: string[] = [];
  const flushList = () => { if (list.length) { out.push(<ul key={`l${out.length}`} className="my-1 list-disc pl-5">{list.map((l, i) => <li key={i}>{inline(l)}</li>)}</ul>); list = []; } };
  const flushPara = () => { if (para.length) { out.push(<p key={`p${out.length}`} className="my-1">{inline(para.join(" "))}</p>); para = []; } };
  for (const raw of lines) {
    const line = raw.trimEnd();
    const li = /^\s*(?:[-•*]|\d+[.)])\s+(.*)$/.exec(line);
    if (li) { flushPara(); list.push(li[1]); continue; }
    if (!line.trim()) { flushPara(); flushList(); continue; }
    const h = /^#{1,4}\s+(.*)$/.exec(line);
    if (h) { flushPara(); flushList(); out.push(<p key={`h${out.length}`} className="mt-2 font-semibold">{inline(h[1])}</p>); continue; }
    flushList(); para.push(line);
  }
  flushPara(); flushList();
  return <div className="space-y-0.5">{out}</div>;
}

function inline(s: string): ReactNode {
  const parts = s.split(/(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) return <strong key={i}>{p.slice(2, -2)}</strong>;
    if (p.startsWith("`") && p.endsWith("`")) return <code key={i} className="rounded bg-gray-100 px-1 text-[13px]">{p.slice(1, -1)}</code>;
    if (p.startsWith("*") && p.endsWith("*") && p.length > 2) return <em key={i}>{p.slice(1, -1)}</em>;
    return <Fragment key={i}>{p}</Fragment>;
  });
}
